import { useEffect, useState } from "react"

 export default function InputLotId({className, name, required, disabled, onChange, value, inputRef}){
    const [parts, setParts] = useState({});

    // parse incoming data
    useEffect(()=>{
        const {section, lot, lotPart} = (value || {});
        setParts({section, lot, lotPart});
    },[value])

    // handle outgoing changes
    function onInputChange(key, value){
        const combined = {...parts, [key]: value};
        onChange({target: {value: combined, type: 'lotPart'}});
    }

    return (
        <div className={`flex ${className || ''}`}>
            <div className="flex flex-col min-w-[1rem] flex-auto ">
                <label htmlFor={name + '_section'} className="font-bold text-sm">Section {required && <span className={`text-red-600 ${disabled?'opacity-0':''}`}>*</span>}</label>
                <input
                    id={name + '_section'}
                    name={name + '_section'}
                    type="text"
                    placeholder="X"
                    onChange={e=>onInputChange('section', e.target.value)}
                    required={required}
                    disabled={disabled}
                    value={parts.section || ''}
                    ref={inputRef}
                    maxLength="1"
                    className="mr-1 p-1 uppercase"
                />
            </div>
            <div className="flex flex-col min-w-[1rem] flex-auto">
                <label htmlFor={name + '_lot'} className="font-bold text-sm">Lot # {required && <span className={`text-red-600 ${disabled?'opacity-0':''}`}>*</span>}</label>
                <input
                    id={name + '_lot'}
                    name={name + '_lot'}
                    type="number"
                    placeholder="123"
                    onChange={e=>onInputChange('lot', e.target.value)}
                    required={required}
                    disabled={disabled}
                    value={parts.lot || ''}
                    min="0"
                    max="999"
                    step="1"
                    className="mr-1 p-1 uppercase"
                />
            </div>
            <div className="flex flex-col min-w-[1rem] flex-auto">
                <label htmlFor={name + '_lotPart'} className="font-bold text-sm">Lot Part</label>
                <input
                    id={name + '_lotPart'}
                    name={name + '_lotPart'}
                    type="text"
                    placeholder="XXXX"
                    onChange={e=>onInputChange('lotPart', e.target.value)}
                    disabled={disabled}
                    value={parts.lotPart || ''}
                    maxLength="4"
                    className="p-1 uppercase"
                />
            </div>
        </div>
    )
    
}